import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faEnvelope, faHeadset, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Trans, useTranslation } from 'react-i18next';
import './helpPage.css';

/* ───────────────── HELP PAGE ─────────────────
   Two matched panels: the hosted assistant on the left, the human contact
   options on the right. Both cards carry the same frame and the same 56px
   header band (the widget's own header height), so the two top edges line up. */
const HelpPage = () => {
  const { t } = useTranslation();
  const BOT_ID = '175252121310850526523KNFKH';

  const openCalendly = () =>
    window.open(
      'https://calendly.com/build-ultimo-bots/live-demo-ultimo-bots',
      '_blank'
    );

  const openMail = () => {
    window.location.href =
      'mailto:build@ultimo-bots.com?subject=Help%20with%20Ultimo%20Bots';
  };

  return (
    <div className="help-page">
      <header className="section-head">
        <h1 className="section-head-title">{t('help')}</h1>
        <p className="section-head-sub">
          {t('help_subtitle')}
        </p>
      </header>

      <div className="help-page-container">
        <section className="help-chat">
          <div className="chat-assistant-container">
            <iframe
              src={`https://chat.ultimo-bots.com/${BOT_ID}`}
              title={t('help_chat_iframe_title')}
              style={{ width: '100%', height: '100%', border: 'none' }}
              allow="microphone"
            />
          </div>
        </section>

        <aside className="help-actions">
          <div className="help-actions-head">
            <span className="help-actions-head-icon">
              <FontAwesomeIcon icon={faHeadset} />
            </span>
            <h2 className="help-actions-head-title">{t('help_connect_heading')}</h2>
          </div>

          <div className="help-actions-body">
            {/* Calendly link */}
            <button type="button" className="help-option" onClick={openCalendly}>
              <span className="help-option-icon">
                <FontAwesomeIcon icon={faCalendarCheck} />
              </span>
              <span className="help-option-text">
                <span className="help-option-title">{t('help_book_demo_button')}</span>
                <span className="help-option-desc">
                  <Trans i18nKey="help_book_demo_text_html" components={{ strong: <strong /> }} />
                </span>
              </span>
              <FontAwesomeIcon className="help-option-arrow" icon={faArrowRight} />
            </button>

            {/* Email link */}
            <button type="button" className="help-option" onClick={openMail}>
              <span className="help-option-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
              <span className="help-option-text">
                <span className="help-option-title">{t('help_email_button')}</span>
                <span className="help-option-desc">{t('help_email_text')}</span>
              </span>
              <FontAwesomeIcon className="help-option-arrow" icon={faArrowRight} />
            </button>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default HelpPage;
